import React from 'react';
import { Box, Flex, Text, Avatar, VStack } from '@chakra-ui/react';
import { Home } from 'lucide-react';
import { useBoardContext } from '../context/BoardContext';
import { useNavigate } from 'react-router-dom';
const TEAL = '#00897B';
const SIDEBAR_BG = '#C8E6C0';
const CELL_BG = '#F1FAF1';
const CELL_ACTIVE_BG = '#B2DFDB';
export const boardMembers = [{
  position: 'Position 1, District 1',
  name: '(Vacant)'
}, {
  position: 'Position 2, District 2',
  name: '(Vacant)'
}, {
  position: 'Position 3, District 2',
  name: 'KYLE SCHULTHEIS'
}, {
  position: 'Position 4, District 3',
  name: 'GREG FERREL'
}, {
  position: 'Position 5, District 1',
  name: '(Vacant)'
}, {
  position: 'Position 6, District 1',
  name: 'DANIEL WESTACOTT'
}, {
  position: 'Position 7, District 2',
  name: '(Vacant)'
}, {
  position: 'Position 8, District 3',
  name: '(Vacant)'
}, {
  position: 'Position 9, District 1',
  name: 'SCOT COCKING'
}, {
  position: 'Position 10, District 2',
  name: 'IAN CLARK'
}, {
  position: 'Position 11, District 2',
  name: 'AARON FLANSBURG'
}, {
  position: 'Position 12, District 3',
  name: 'DAN MCKINLEY'
}];
export function BoardSidebar() {
  const {
    selectedIndex,
    setSelectedIndex
  } = useBoardContext();
  const navigate = useNavigate();
  return <Box as="nav" bg={SIDEBAR_BG} w="290px" minW="290px" position="fixed" top="64px" left={0} bottom={0} zIndex={90} display="flex" flexDirection="column" overflowY="hidden" data-id="element-49">
      {/* User Box */}
      <Flex align="center" gap={3} px={4} py={4} borderBottom="1px solid rgba(0,137,123,0.25)" flexShrink={0} data-id="element-50">
        <Avatar name="Keith Price" bg="#7B1FA2" color="white" size="md" fontWeight="bold" getInitials={() => 'KP'} data-id="element-51" />

        <Box data-id="element-52">
          <Text fontWeight="bold" color={TEAL} fontSize="md" lineHeight="1.2" data-id="element-53">
            Keith Price
          </Text>
          <Text color={TEAL} fontSize="sm" opacity={0.85} data-id="element-54">
            zMagic Solutions
          </Text>
        </Box>
      </Flex>

      {/* Home nav item */}
      <Box flexShrink={0} pt={2} mb={2} data-id="element-55">
        <Flex align="center" gap={4} px={5} py={3} cursor="pointer" borderRadius="md" _hover={{
        bg: 'rgba(0,137,123,0.12)'
      }} onClick={() => navigate('/welcome')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && navigate('/welcome')} data-id="element-56">
          <Box color={TEAL} flexShrink={0} data-id="element-57">
            <Home size={26} strokeWidth={1.8} data-id="element-58" />
          </Box>
          <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-59">
            Home
          </Text>
        </Flex>
      </Box>

      {/* Board member list */}
      <Box flex={1} overflowY="auto" px={3} pt={2} pb={2} sx={{
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#A5D6A7',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#00897B',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#00695C'
      },
      scrollbarColor: '#00897B #A5D6A7',
      scrollbarWidth: 'thin'
    }} data-id="element-60">
        <VStack align="stretch" spacing={1} data-id="element-61">
          {boardMembers.map((member, idx) => {
          const isSelected = idx === selectedIndex;
          return <Box key={idx} bg={isSelected ? CELL_ACTIVE_BG : CELL_BG} borderRadius="sm" px={3} py={1.5} borderLeft="3px solid" borderLeftColor={isSelected ? '#004D40' : TEAL} cursor="pointer" onClick={() => setSelectedIndex(idx)} _hover={{
            bg: isSelected ? CELL_ACTIVE_BG : '#E0F2E9'
          }} transition="background 0.15s" data-id="element-62">
                <Text fontSize="10px" fontWeight="600" color={isSelected ? '#004D40' : TEAL} textTransform="uppercase" letterSpacing="0.06em" lineHeight="1.3" data-id="element-63">
                  {member.position}
                </Text>
                <Text fontSize="sm" fontWeight={member.name === '(Vacant)' ? 'normal' : 'semibold'} color={member.name === '(Vacant)' ? 'gray.400' : isSelected ? '#004D40' : 'black'} fontStyle={member.name === '(Vacant)' ? 'italic' : 'normal'} lineHeight="1.3" data-id="element-64">
                  {member.name}
                </Text>
              </Box>;
        })}
        </VStack>
      </Box>
    </Box>;
}